'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _createClass = require('@babel/runtime/helpers/createClass');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

/**
 * doc
 * import avatarNative from 'xxx/jsbridge'
 *
 * 注入方法 可在初始化 options 注入要使用的方法
 * 也可手动注入
 * 有回调
 * avatarNative.registerMethods([], true)
 * 无回调
 * avatarNative.registerMethods([], false)
 * 使用
 * avatarNative.getUserInfo().then(res => {
 *  console.log(res)
 * })
 *
 * scheme
 * 跳转登录: avatar://jsblogin
 */
var ARRAY_CLASS = '[object Array]';
var _toString = Object.prototype.toString;
/**
 * set default options
 */

var options = {
  initMethodsWithCallBack: [],
  initMethodsWithoutCallBack: []
};

var AvatarJsBridge = /*#__PURE__*/function () {
  function AvatarJsBridge() {
    _classCallCheck__default["default"](this, AvatarJsBridge);

    _defineProperty__default["default"](this, "_callbakFns", {});

    _defineProperty__default["default"](this, "_callbackId", 0);

    _defineProperty__default["default"](this, "_GLOBAL_NAME", 'AvatarJsBridge');

    _defineProperty__default["default"](this, "_NATIVE_NAME", 'AvatarNative');

    _defineProperty__default["default"](this, "appInfo", null);

    _defineProperty__default["default"](this, "getInjectUserInfo", this.injectUserInfo);

    var initMethodsWithCallBack = options.initMethodsWithCallBack;
    var initMethodsWithoutCallBack = options.initMethodsWithoutCallBack;
    this.isIos = this._isIos();
    this.isAndroid = this._isAndroid();
    this.isWeb = this._isWeb();

    if (_toString.call(initMethodsWithCallBack) === ARRAY_CLASS && initMethodsWithCallBack.length !== 0) {
      this.registerMethods(initMethodsWithCallBack, true);
    }

    if (_toString.call(initMethodsWithoutCallBack) === ARRAY_CLASS && initMethodsWithoutCallBack.length !== 0) {
      this.registerMethods(initMethodsWithoutCallBack, false);
    }

    if (!this.isWeb) this.injectUserInfo();
    this.mountToWindow();
  } // is ios flag


  _createClass__default["default"](AvatarJsBridge, [{
    key: "_isIos",
    value: function _isIos() {
      return !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[this._NATIVE_NAME]);
    } // is android flag

  }, {
    key: "_isAndroid",
    value: function _isAndroid() {
      return !!window[this._NATIVE_NAME];
    } // is web flag

  }, {
    key: "_isWeb",
    value: function _isWeb() {
      return !this.isIos && !this.isAndroid;
    } // register method width callback in window

  }, {
    key: "_registerMethod",
    value: function _registerMethod(method) {
      var _this = this;

      _this[method] = function (param) {
        return new Promise(function (resolve, reject) {
          _this._callNative(method, param, function (result) {
            resolve(result);
          }) ? void 0 : reject("".concat(method, " not handled or not in app."));
        });
      };
    } // register method widthout callback in window

  }, {
    key: "_registerMethodWithoutMethod",
    value: function _registerMethodWithoutMethod(method) {
      var _this = this;

      _this[method] = function (param) {
        return new Promise(function (resolve, reject) {
          _this._callNative(method, param, null) ? resolve('success') : reject("".concat(method, " not handled."));
        });
      };
    } // window call app method

  }, {
    key: "_callNative",
    value: function _callNative(name, param, callbackFn) {
      var callbackId = 0;

      if (typeof callbackFn === 'function') {
        this._callbackId++;
        callbackId = this._callbackId;
        this._callbakFns[callbackId] = callbackFn;
      }

      var pm = JSON.stringify({
        name: name,
        callbackId: callbackId ? callbackId.toString() : '',
        param: param || {}
      });

      if (this.isAndroid) {
        window[this._NATIVE_NAME].postMessage(pm);

        return true;
      }

      if (this.isIos) {
        window.webkit.messageHandlers[this._NATIVE_NAME].postMessage(pm);

        return true;
      }

      if (process && process.env.NODE_ENV === 'development') return true;
      return false;
    } // app call window method

  }, {
    key: "nativeCall",
    value: function nativeCall(name, callbackId, result) {
      var wFun = window[callbackId];
      var fun = callbackId && this._callbakFns[callbackId];
      var data = this._isAndroid() && typeof result === 'string' ? JSON.parse(result) : result; // 特殊处理上传 连续回调问题

      if (wFun && typeof wFun === 'function') {
        wFun(data);
        return;
      }

      delete this._callbakFns[callbackId];
      if (fun && typeof fun === 'function') fun(data);
    } // batch register methods

  }, {
    key: "registerMethods",
    value: function registerMethods(methods, widthCallback) {
      var _this2 = this;

      if (undefined === widthCallback) throw Error('widthCallback flag not defined, registerMethods should take second param value(true/false) for is not has callback.');
      methods.forEach(function (m) {
        widthCallback === true ? _this2._registerMethod(m) : _this2._registerMethodWithoutMethod(m);
      });
    } // async call app method do not need register

  }, {
    key: "asyncCallNative",
    value: function asyncCallNative(method, param) {
      var _this = this;

      return new Promise(function (resolve) {
        _this._callNative(method, param || {}, function (result) {
          resolve(result);
        });
      });
    } // call app method direct without register and callback

  }, {
    key: "callNative",
    value: function callNative(method, param) {
      return this._callNative(method, param || {}, null);
    } // check method

  }, {
    key: "canIUse",
    value: function canIUse(methods) {
      var hasVersionParam = ('avatrVersion' in (this.injectUserInfo() || {}));

      if (hasVersionParam) {
        return this.asyncCallNative('canIUse', {
          methods: methods
        });
      }

      return Promise.resolve({
        result: false
      });
    }
  }, {
    key: "injectUserInfo",
    value: function injectUserInfo() {
      var avatarUa = '',
          userStr = '';
      var ua = window.navigator.userAgent;
      var reg1 = /Avatar\((.+?)\)/g; // eslint-disabled-next-line

      var reg2 = /[^()]+(?=\))/g;
      var st1 = ua.match(reg1);

      if (st1 && (avatarUa = st1[0])) {
        var st2 = avatarUa.match(reg2);
        if (st2) userStr = st2[0];
        this.appInfo = this.parsingData(userStr);
        return this.appInfo;
      }

      return null;
    }
  }, {
    key: "parsingData",
    value: function parsingData(str) {
      var data = {};
      var paramsArr = str.split(';');

      for (var i = 0; i < paramsArr.length; i++) {
        var _data = paramsArr[i];

        if (_data) {
          var _arr = _data.split('=');

          data["".concat(_arr[0])] = _arr[1];
        }
      }

      return data;
    } // register jsbridge to window

  }, {
    key: "mountToWindow",
    value: function mountToWindow() {
      window[this._GLOBAL_NAME] = this;
    }
  }]);

  return AvatarJsBridge;
}();

var index = new AvatarJsBridge();

exports["default"] = index;
